const allowedTags = new Set([
    "A",
    "BR",
    "EM",
    "LI",
    "OL",
    "P",
    "SPAN",
    "STRONG",
    "U",
    "UL"
]);

const allowedFontFamilies = new Set([
    "Arial",
    "Georgia",
    "Verdana",
    "monospace"
]);

function sanitizeLink(value) {
    try {
        const url = new URL(value, window.location.origin);
        return ["http:", "https:", "mailto:"].includes(url.protocol) ? value : "";
    } catch {
        return "";
    }
}

export function sanitizeResourceUrl(value, { allowDataImage = false } = {}) {
    if (typeof value !== "string") return "";

    if (allowDataImage && /^data:image\/(avif|gif|jpeg|png|webp);base64,/i.test(value)) {
        return value;
    }

    try {
        const url = new URL(value, window.location.origin);
        return ["http:", "https:"].includes(url.protocol) ? value : "";
    } catch {
        return "";
    }
}

function sanitizeElement(element) {
    if (!allowedTags.has(element.tagName)) {
        element.replaceWith(...element.childNodes);
        return;
    }

    const attributes = Array.from(element.attributes);
    attributes.forEach(attribute => element.removeAttribute(attribute.name));

    if (element.tagName === "A") {
        const href = sanitizeLink(attributes.find(attribute => attribute.name === "href")?.value || "");
        if (href) {
            element.setAttribute("href", href);
            element.setAttribute("target", "_blank");
            element.setAttribute("rel", "noopener noreferrer");
        }
    }

    if (element.tagName === "SPAN") {
        const styleValue = attributes.find(attribute => attribute.name === "style")?.value || "";
        const temporaryElement = document.createElement("span");
        temporaryElement.setAttribute("style", styleValue);
        const fontFamily = temporaryElement.style.fontFamily.replace(/["']/g, "");

        if (allowedFontFamilies.has(fontFamily)) {
            element.style.fontFamily = fontFamily;
        }
    }
}

export function sanitizeHtml(html = "") {
    if (!html || typeof DOMParser === "undefined") return "";

    const documentNode = new DOMParser().parseFromString(html, "text/html");
    Array.from(documentNode.body.querySelectorAll("*")).forEach(sanitizeElement);

    return documentNode.body.innerHTML;
}
